import { createFileRoute } from "@tanstack/react-router";
import { CreatorScreen } from "../screens/CreatorScreen";
import { CreatorMachineProvider } from "@/machines/CreatorProvider.tsx";
import { getInstanceIdFromSubdomain } from "@/utils/subdomain";

export const Route = createFileRoute("/creator")({
  component: CreatorScreenRoute,
  loader: () => {
    const instanceId = getInstanceIdFromSubdomain();
    if (!instanceId) {
      throw new Error("No instance ID found in subdomain");
    }
    return { instanceId };
  },
  remountDeps: () => {
    const instanceId = getInstanceIdFromSubdomain();
    return ["creator", instanceId];
  },
});

function CreatorScreenRoute() {
  const { instanceId } = Route.useLoaderData();
  
  return (
    <CreatorMachineProvider instanceId={instanceId}>
      <CreatorScreen />
    </CreatorMachineProvider>
  );
}
